import { render, staticRenderFns } from "./setWinInfo.vue?vue&type=template&id=262378cb&scoped=true&"
import script from "./setWinInfo.vue?vue&type=script&lang=js&"
export * from "./setWinInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262378cb",
  null
  
)

export default component.exports